import React, { useState } from 'react';
import Draggable from 'react-draggable';
import { Container, Row, Col } from 'react-bootstrap';
import { LeftCol, MiddleCol, RightCol } from './components/styled/Col.styled';
import Education from './components/public/Education';
import Experience from './components/public/Experience';
import PersonalInfo from './components/public/PersonalInfo';
import Volunteering from './components/public/Volunteering';
import Summary from './components/public/Summary';
import Profiles from './components/public/Profiles';
import SoftwaresSkills from './components/public/SoftwaresSkills';
import ProfessionalGoal from './components/public/ProfessionalGoal';
import Projects from './components/public/Projects';
import { useMediaQuery } from 'react-responsive';
import GetInTouch from './components/public/GetInTouch';
import SpringDemo from './components/public/AnimationLeftToRight';
import AnimationLeftToRight from './components/public/AnimationLeftToRight';
import AnimationUpToBottom from './components/public/AnimationUpToBottom';
import AnimationRightToLeft from './components/public/AnimationRightToLeft';
import DownloadCV from './components/public/DownloadCV';
import ProjectPreview from './components/public/ProjectPreview';

const Main = () => {
    const [project, setProject] = useState(null);
    console.log(project);

    const isMax575px = useMediaQuery({
        query: "(max-device-width: 575px)",
    });
    const isMin576px = useMediaQuery({
        query: "(min-device-width: 576px)",
    });

    const isMax767px = useMediaQuery({
        query: "(max-device-width: 767px)",
    });
    const isMin768px = useMediaQuery({
        query: "(min-device-width: 768px)",
    });

    const isMax991px = useMediaQuery({
        query: "(max-device-width: 991px)",
    });
    const isMin992px = useMediaQuery({
        query: "(min-device-width: 992px)",
    });
    const isMax1199px = useMediaQuery({
        query: "(max-device-width: 1199px)",
    });
    const isMin1200px = useMediaQuery({
        query: "(min-device-width: 1200px)",
    });

    return (
        <Container fluid>
            <DownloadCV />
            <Row className='gx-3'>
                <LeftCol xs={12} sm={5} md={5} lg={4} xl={3}>
                    <AnimationLeftToRight>
                        {isMax575px ? <>
                            <PersonalInfo />
                            <Summary />
                            <Profiles setProject={setProject} />
                            <Projects />
                            <Experience />
                            <Education />
                            <Volunteering />
                            <SoftwaresSkills />
                            <ProfessionalGoal />
                        </> : <></>}
                        {isMin576px && isMax767px ? <>

                            <PersonalInfo />
                            <Summary />
                        </> : <></>}
                        {isMin768px && isMax991px ? <>

                            <PersonalInfo />
                            <Summary />
                            <SoftwaresSkills />
                            <ProfessionalGoal />
                        </> : <></>}
                        {isMin992px && isMax1199px ? <>

                            <PersonalInfo />
                            <Summary />
                            <Profiles />
                            <SoftwaresSkills />
                            <ProfessionalGoal />
                        </> : <></>}
                        {isMin1200px ? <>

                            <PersonalInfo />
                            <Summary />
                        </> : <></>}
                    </AnimationLeftToRight>

                </LeftCol>

                <MiddleCol xs={12} sm={7} md={7} lg={8} xl={6}>
                    <AnimationUpToBottom>
                        {isMin576px && isMax767px ? <>

                            <Profiles />
                            <SoftwaresSkills />
                            <ProfessionalGoal />
                        </> : <></>}
                        {isMin768px && isMax991px ? <>

                            <Projects setProject={setProject} />
                            <Profiles />
                        </> : <></>}
                        {isMin992px && isMax1199px ? <>

                            <Projects setProject={setProject} />
                            <Experience />
                            <Education />
                            <Volunteering />
                        </> : <></>}
                        {isMin1200px ? <>
                            {project ?
                                <ProjectPreview project={project} setProject={setProject} />
                                : <>
                                    <Projects setProject={setProject} />
                                    <Experience />
                                    <Education />
                                    <Volunteering />
                                    <GetInTouch />
                                </>}
                        </> : <></>}
                    </AnimationUpToBottom>
                </MiddleCol>
                <RightCol xs={12} sm={12} md={12} xl={3}>
                    <AnimationRightToLeft>
                        {isMin576px && isMax767px ? <>
                            <Projects setProject={setProject} />
                            <Experience />
                            <Education />
                            <Volunteering />
                        </> : <></>}
                        {isMin768px && isMax991px ? <>
                            <Experience />
                            <Education />
                            <Volunteering />
                        </> : <></>}
                        {isMin1200px ? <>

                            <Profiles />
                            <SoftwaresSkills />
                            <ProfessionalGoal />
                        </> : <></>}
                    </AnimationRightToLeft>
                </RightCol>
            </Row>
        </Container >
    );
};

export default Main;